exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".orange-ed496999{color:#FA6400}span.darkgrey-f5c59bc9{color:#2A2A2A}\n", ""]);

// Exports
exports.locals = {
	"orange": "orange-ed496999",
	"darkgrey": "darkgrey-f5c59bc9"
};